import { BaseProjectDevelopmentStructure } from './project-development-section-types';

export const BASE_PROJECT_DEVELOPMENT_CONFIG: BaseProjectDevelopmentStructure = {
  title: 'Разработка проекта',
  description:
    'Проектная документация содержит всю техническую информацию и\u00A0аксонометрические схемы. Позволяет разработать техническое решение, подобрать оборудование и\u00A0рассчитать стоимость всего проекта. Монтаж и\u00A0оборудование оплачиваются отдельно, согласно проектной смете.',
};
